import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { CoreModule } from './core/core.module';
import { AppComponent } from './app.component';
import { SentryModule } from './core/integration/sentry/sentry.module';

@NgModule({
  imports: [CoreModule, SentryModule.forRoot()],
  declarations: [AppComponent],
  providers: [provideZoneChangeDetection()],
  bootstrap: [AppComponent]
})
export class AppModule {}
